import { render, staticRenderFns } from "./UniversalFilter.vue?vue&type=template&id=34d5b6a6&scoped=true"
import script from "./UniversalFilter.vue?vue&type=script&lang=js"
export * from "./UniversalFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d5b6a6",
  null
  
)

export default component.exports